// Components
export { Modal } from './Modal';
export { ModalContainer } from './ModalContainer';

// Types
export type { ModalProps } from './Modal';

// Registry
export { modalRegistry } from './modal-registry';

// Styles (import in global CSS)
import './modal-animations.css';
